import * as t from './actionTypes';

export const initialState = {
  campaigns: {},
  dataFeeds: [],
  isFetchingTemplates: false, // loading state specifically used for fetching templates,
  loading: false, // general loading state
  senders: {},
  templateDetailsById: {},
  templatesById: {},
  templatesListQueries: {},
  membersById: {},
};

const templatePickerReducer = (
  state = initialState,
  action: {
    type: string;
    query: any;
    templatesIds: any;
    total: number;
    templatesById: any;
    templateId: number;
    templateDetails: any;
    smsSenders: any;
    authedEmails: any;
    campaign: { id: any };
    dataFeeds: any;
    membersById: any;
  },
) => {
  switch (action.type) {
    case t.CLONE_TEMPLATE_REQUEST:
    case t.COPY_TEMPLATE_TO_CAMPAIGN_REQUEST:
    case t.CREATE_BEE_TEMPLATE_REQUEST:
    case t.CREATE_CAMPAIGN_TEMPLATE_REQUEST:
    case t.CREATE_TEMPLATE_REQUEST:
    case t.FETCH_CAMPAIGN_DETAILS_REQUEST:
    case t.FETCH_DATA_FEEDS_REQUEST:
    case t.FETCH_SENDERS_REQUEST:
    case t.IMPORT_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case t.FETCH_TEMPLATES_REQUEST:
      return {
        ...state,
        isFetchingTemplates: true,
      };
    case t.FETCH_TEMPLATES_RESPONSE:
      return {
        ...state,
        isFetchingTemplates: false,
        templatesListQueries: {
          ...state.templatesListQueries,
          [action.query]: {
            templateIds: action.templatesIds,
            total: action.total,
          },
        },
        templatesById: {
          ...state.templatesById,
          ...action.templatesById,
        },
      };
    case t.CLONE_TEMPLATE_ERROR:
    case t.COPY_TEMPLATE_TO_CAMPAIGN_ERROR:
    case t.CREATE_BEE_TEMPLATE_RESPONSE:
    case t.CREATE_CAMPAIGN_TEMPLATE_ERROR:
    case t.CREATE_TEMPLATE_RESPONSE:
    case t.IMPORT_TEMPLATE_RESPONSE:
    case t.FETCH_CAMPAIGN_DETAILS_ERROR:
    case t.FETCH_DATA_FEEDS_ERROR:
    case t.FETCH_SENDERS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case t.FETCH_TEMPLATE_DETAILS_RESPONSE:
      return {
        ...state,
        templateDetailsById: {
          ...state.templateDetailsById,
          [action.templateId]: action.templateDetails,
        },
      };
    case t.FETCH_SENDERS_RESPONSE:
      return {
        ...state,
        loading: false,
        senders: {
          smsSenders: action.smsSenders,
          authedEmails: action.authedEmails,
        },
      };
    case t.FETCH_CAMPAIGN_DETAILS_RESPONSE:
      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          [action.campaign.id]: action.campaign,
        },
      };
    case t.FETCH_DATA_FEEDS_RESPONSE:
      return {
        ...state,
        dataFeeds: action.dataFeeds,
        loading: false,
      };
    case t.FETCH_MEMBER_DATA_RESPONSE:
      return {
        ...state,
        membersById: {
          ...state.membersById,
          ...action.membersById,
        },
      };
    default:
      return state;
  }
};

export default templatePickerReducer;
